import React from 'react'
import {debounce, isEmpty} from 'lodash'
import AutoComplete from 'material-ui-legacy/AutoComplete'

import errors from '../../lib/errors.js'
import ErrorDialog from './ErrorDialog'

/*
Props:
- name: field name
- value: text value
- dataStore: a Store component to be used to get autocomplete matches
- autoCompleteFilter: filter that will receive the field value
- autoCompleteAttribute: store attribute use as autocomplete data
- validatedOnChange: callback function for onChange, but including a
  validation flag and field name:
  callback(value, Bool(isValid), this.props.name)
- required: boolean (false)
- errorMessage: Error message to be displayed (can be set by external form
  validation)
- debounceTime: throttling for autocomplete data requests. Default: 250ms
- maxSearchResults: Maximum results to show in dropdown. Default: 10
- openOnFocus: Should the dropdown be open on focus
*/
class AutoCompleteInput extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: (this.props.value || ''),
      dataSource: [],
      error: '',
      errorMessage: ''
    }

    const debounceTime = this.props.debounceTime || 250
    this._loadData = debounce(this._loadData, debounceTime)
    this.maxSearchResults = this.props.maxSearchResults || 10
  }

  componentWillMount() {
    if (this.props.openOnFocus) this._loadData()
  }

  _loadData = () => {
    const DataStore = this.props.dataStore
    let filter = {}
    filter[this.props.autoCompleteFilter] = this.state.value
    DataStore.findAll(filter, [], 1, this.maxSearchResults)
    .then((result) => {
      const dataSource = result.data.map((item) => {
        return {
          text: item.attributes[this.props.autoCompleteAttribute],
          value: item.id
        }
      })
      this.setState({dataSource: dataSource})
    })
    .catch((error) => {
      this.setState({error: errors.unpack(error)})
    })
  }

  _change = (value) => {
    const errorMessage = (this.props.errorMessage || 'Field is required')
    const newState = (
      (this.props.required && !value) ?
      {value: value, errorMessage: errorMessage} :
      {value: value, errorMessage: ''}
    )
    this.setState(
      newState,
      () => {
        this._loadData()
        this._validatedOnChange()
      }
    )}

  _chosen = (chosenValue) => {
    const fieldValue = (
      (typeof(chosenValue) === 'object') ?
      chosenValue.text :
      chosenValue
    )
    this._change(fieldValue)
  }

  _validatedOnChange = (value = this.state.value) => {
    value = value.trim()
    if (!this.props.validatedOnChange) return
    this.props.validatedOnChange(
      value,
      (this.props.required ? !isEmpty(value) : true),
      this.props.name
    )
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    let autoCompleteStyle = this.props.style || {}

    return (
      <div>
        <AutoComplete
          value={this.state.value}
          style={autoCompleteStyle}
          hintText={this.props.hintText}
          filter={AutoComplete.noFilter}
          floatingLabelText={this.props.floatingLabelText}
          dataSource={this.state.dataSource}
          onUpdateInput={this._change}
          onNewRequest={this._chosen}
          onBlur={() => this._change(this.state.value)}
          fullWidth={this.props.fullWidth}
          maxSearchResults={this.maxSearchResults}
          searchText={this.state.value}
          errorText={this.state.errorMessage}
          openOnFocus={this.props.openOnFocus}
        />

        {Boolean(this.state.error) &&
          <ErrorDialog
            open={Boolean(this.state.error)}
            closeCallback={this._closeErrorDialog}
            title="Couldn't read autocomplete data">
            <p>
              <strong>Error:</strong> {this.state.error}
            </p>
          </ErrorDialog>
        }

      </div>
    )
  }
}

export default AutoCompleteInput



// WEBPACK FOOTER //
// ./src/components/UI/AutoCompleteInput.jsx